import {
  header_styles_default
} from "./chunk.U3V27DHE.js";
import {
  container_styles_default
} from "./chunk.USJQKTI6.js";
import {
  ApplicationSection
} from "./chunk.3TZLHWFR.js";
import {
  o
} from "./chunk.OBPYZVEK.js";
import {
  n
} from "./chunk.D5EJUUKV.js";
import {
  $
} from "./chunk.4JTBA2KG.js";
import {
  __decorateClass
} from "./chunk.K2NRSETB.js";

// src/components/header/header.ts
var FadvHeader = class extends ApplicationSection {
  render() {
    return $`<div class=${o({
      header: true
    })} >${this.renderContainer()}</div>`;
  }
};
FadvHeader.styles = [container_styles_default, header_styles_default];
FadvHeader = __decorateClass([
  n("fadv-header")
], FadvHeader);

export {
  FadvHeader
};
